// // fingerprintSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFingerprintVerified: false,
};

const fingerprintSlice = createSlice({
  name: "fingerprint",
  initialState,
  reducers: {
    fingerprintVerifySuccess(state) {
      state.isFingerprintVerified = true;
    },
    fingerprintVerifyReset(state) {
      state.isFingerprintVerified = false;
    },
  },
});

export const { fingerprintVerifySuccess, fingerprintVerifyReset } =
  fingerprintSlice.actions;
export default fingerprintSlice.reducer;

// CHANGES BY KHALID STARTS 15/10/24

// fingerprintSlice.js
// import { createSlice } from "@reduxjs/toolkit";
// import { loginSuccess } from "./authSlice"; // Import loginSuccess from authSlice

// const initialState = {
//   isFingerprintVerified: false,
// };

// const fingerprintSlice = createSlice({
//   name: "fingerprint",
//   initialState,
//   reducers: {
//     fingerprintVerifySuccess(state, action) {
//       state.isFingerprintVerified = true;

//       // Ensure the payload has the necessary data
//       const { token, userData } = action.payload || {}; // Fallback to empty object if undefined
//       if (token && userData) {
//         debugger;
//         loginSuccess({ token, userData }); // Save token after fingerprint match
//       } else {
//         console.error("Payload is missing token or userData", action.payload);
//       }
//     },
//     fingerprintVerifyReset(state) {
//       state.isFingerprintVerified = false;
//     },
//   },
// });

// export const { fingerprintVerifySuccess, fingerprintVerifyReset } =
//   fingerprintSlice.actions;
// export default fingerprintSlice.reducer;

// CHANGES BY KHALID ENDS 15/10/24
